<p-dialog header="Action Item Audit" [(visible)]="isActionItemAuditModalShow" [draggable]="false"
    [style]="{ width: '100vw', height: '98vh' }" (onHide)="closeActionItemAuditModal()" [modal]="true"
    id="actionItemAuditModal">
    <app-action-item-audit-trial [actionItemNumber]="actionItemNumber">
    </app-action-item-audit-trial>
</p-dialog>
